import { ColumnsSettingsViewDict } from '../typings/common';
import { ReportRequestSetData } from '../typings/reports';
import { ReportDomain } from '../typings/reportsDomain';

export const FETCH_REPORTS_DOMAIN = 'FETCH_REPORTS_DOMAIN';
export type FETCH_REPORTS_DOMAIN = typeof FETCH_REPORTS_DOMAIN;

export interface FetchReportsDomain {
    type: FETCH_REPORTS_DOMAIN;
}

export function fetchReportsDomain(): FetchReportsDomain {
    return {
        type: FETCH_REPORTS_DOMAIN
    };
}

export const UPDATE_REPORTS_DOMAIN = 'UPDATE_REPORTS_DOMAIN';
export type UPDATE_REPORTS_DOMAIN = typeof UPDATE_REPORTS_DOMAIN;

export interface UpdateReportsDomain {
    type: UPDATE_REPORTS_DOMAIN;
    reportsDomain: Array<ReportDomain>;
}

export function updateReportsDomain(reportsData: Array<ReportDomain>): UpdateReportsDomain {
    return {
        type: UPDATE_REPORTS_DOMAIN,
        reportsDomain: reportsData
    };
}

export const ADD_REPORT_DOMAIN = 'ADD_REPORT_DOMAIN';
export type ADD_REPORT_DOMAIN = typeof ADD_REPORT_DOMAIN;

export interface AddReportDomain {
    type: ADD_REPORT_DOMAIN;
    period: ReportRequestSetData;
}

export function addReportDomain(period: ReportRequestSetData): AddReportDomain {
    return {
        type: ADD_REPORT_DOMAIN,
        period
    };
}

export const STOP_REPORTS_DOMAIN_LOADING = 'STOP_REPORTS_DOMAIN_LOADING';
export type STOP_REPORTS_DOMAIN_LOADING = typeof STOP_REPORTS_DOMAIN_LOADING;

export interface StopReportsDomainLoading {
    type: STOP_REPORTS_DOMAIN_LOADING;
}

export const stopReportsDomainLoading: StopReportsDomainLoading = {
    type: STOP_REPORTS_DOMAIN_LOADING
};

export const CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY = 'CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY';
export type CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY = typeof CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY;

export interface ReportsDomainColumnsVisibilityChangeData {
    type: CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY;
    columns: ColumnsSettingsViewDict;
}

export function changeReportsDomainColumnsVisibility(
    columns: ColumnsSettingsViewDict
): ReportsDomainColumnsVisibilityChangeData {
    return {
        type: CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY,
        columns
    };
}

export const CHANGE_REPORTS_DOMAIN_GRID_ORDER = 'CHANGE_REPORTS_DOMAIN_GRID_ORDER';
export type CHANGE_REPORTS_DOMAIN_GRID_ORDER = typeof CHANGE_REPORTS_DOMAIN_GRID_ORDER;

export interface ReportsDomainColumnsOrderChangeData {
    type: CHANGE_REPORTS_DOMAIN_GRID_ORDER;
    columnOrder: Array<string>;
}

export function changeReportsDomainColumnsOrder(columnOrder: Array<string>): ReportsDomainColumnsOrderChangeData {
    return {
        type: CHANGE_REPORTS_DOMAIN_GRID_ORDER,
        columnOrder
    };
}

export const UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH = 'UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH';
export type UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH = typeof UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH;

export interface UpdateReportsDomainColumnsWidthData {
    type: UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH;
    columns: ColumnsSettingsViewDict;
}

export function updateReportsDomainColumnsWidthData(
    columns: ColumnsSettingsViewDict
): UpdateReportsDomainColumnsWidthData {
    return {
        type: UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH,
        columns
    };
}

export const HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE = 'HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE';
export type HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE = typeof HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE;

export interface HandleReportsDomainColumnsVisibilityChangeAction {
    type: HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE;
    columns: string[];
}

export function handleReportsDomainColumnsVisibilityChange(
    columns: string[]
): HandleReportsDomainColumnsVisibilityChangeAction {
    return {
        type: HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE,
        columns
    };
}

export const HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE = 'HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE';
export type HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE = typeof HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE;

export interface HandleReportsDomainColumnsOrderChangeAction {
    type: HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE;
    columnOrder: string[];
}

export function handleReportsDomainColumnsOrderChange(
    columnOrder: string[]
): HandleReportsDomainColumnsOrderChangeAction {
    return {
        type: HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE,
        columnOrder
    };
}

export const HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE = 'HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE';
export type HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE = typeof HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE;

export interface HandleReportsDomainColumnsWidthUpdateAction {
    type: HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE;
    width: number;
    key: string;
}

export function handleReportsDomainColumnsWidthUpdate(
    width: number,
    key: string
): HandleReportsDomainColumnsWidthUpdateAction {
    return {
        type: HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE,
        width,
        key
    };
}

export const UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE = 'UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE';
export type UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE = typeof UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE;

export interface UpdateColumnsSettingsReportsDomainState {
    type: UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE;
    columnsSettings: ColumnsSettingsViewDict;
}

export const updateColumnsSettingsReportsDomainState = (
    columnsSettings: ColumnsSettingsViewDict
): UpdateColumnsSettingsReportsDomainState => {
    return {
        type: UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE,
        columnsSettings
    };
};

export type ReportsDomainAction =
    | FetchReportsDomain
    | UpdateReportsDomain
    | AddReportDomain
    | ReportsDomainColumnsVisibilityChangeData
    | UpdateReportsDomainColumnsWidthData
    | StopReportsDomainLoading
    | ReportsDomainColumnsOrderChangeData
    | HandleReportsDomainColumnsVisibilityChangeAction
    | HandleReportsDomainColumnsOrderChangeAction
    | HandleReportsDomainColumnsWidthUpdateAction
    | UpdateColumnsSettingsReportsDomainState;
